import React, { useState, useEffect } from 'react';
import { createRoot } from "react-dom/client";
import FilterUI from "./FilterUI";
import './App.css';
import { parseFilterUrl } from './helpers/url'
import { createTopFilters } from './helpers/global'

// import _filter_data from './data';
// import _filter_form from './data-form';
function App() {

  const top_filter = createTopFilters(_top_filter, language);

  const _filter_settings = parseFilterUrl(_filter_form, _filter_options, top_filter);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState(_filter_data);
  const [error, setError] = useState(null);
  const [streaming, setStreaming] = useState(true);
  const [offset, setOffset] = useState(_offset);
  const fetchData = () => {
    fetch(_filter_streaming.data_url + '?' + new URLSearchParams({
      offset: offset,
      limit: _limit,
    }))
      .then((res) => {
        return res.json()
      })
      .then((result) => {
        if (typeof result.success !== "undefined" && result.success === false) {
          setIsLoaded(true);
          return result;
        } else {
          setIsLoaded(true);
          if (typeof (items) !== "undefined" && items.length) {
            setItems((items) => items.concat(result))

          } else {
            setItems((items) => result)
          }
          return result;
        }
      })
      .then((result) => {

        setOffset((offset) => offset + result.length);
        if (result.length !== 0 && result.length >= _limit) {
          setStreaming(true);
        } else {
          setStreaming(false);
        }
      })
      .catch(function (err) {
        console.log(`Error: ${err}`)
      });
  }

  useEffect(() => {
    if (streaming) {
      fetchData();
    }
  }, [offset]);

  if (error) {
    return "<div>Error: {error.message}</div>";

  } else {
    return (
      <>

        <FilterUI
          items={items}
          filterForm={_filter_form}
          topFilter={top_filter}
          filterSettings={_filter_settings}
          language={language}

        />
      </>
    );
  }
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App tab='home' />);
